import { apiClient } from './client';
import { App, CreateAppRequest, UpdateAppRequest } from '../types';

export const appsApi = {
  getApps: async (page = 1, limit = 10): Promise<App[]> => {
    return apiClient.get(`/admin/apps?page=${page}&limit=${limit}`);
  },

  createApp: async (app: CreateAppRequest): Promise<App> => {
    return apiClient.post('/admin/apps', app);
  },

  updateApp: async (appId: number, app: UpdateAppRequest): Promise<App> => {
    return apiClient.put(`/admin/apps/${appId}`, app);
  },

  deleteApp: async (appId: number): Promise<void> => {
    return apiClient.delete(`/admin/apps/${appId}`);
  },
};
